import { useCallback } from 'react';
import { getOptions } from 'helpers/getOptions';
import { useDispatch } from 'react-redux';
import $api from 'http/index';
import store from 'store/store';
import schedulePageActions from 'store/schedule/schedulePageActions';

export const useGridSetPosition = () => {
  const dispatch = useDispatch();
  const gridSetPosition = useCallback(async ({ sheetId, gridPosition, destinationSheetId }) => {
    const state = store.getState().schedule;
    try {
      const data = {
        sheetId, gridPosition, destinationSheetId, conflictAction: destinationSheetId ? 'swap' : null
      }
      await $api.post(
        `${process.env.REACT_APP_BASE_URL}/sheets/schedule/grid-position`,
        data,
        getOptions()
      );

      if (destinationSheetId) {
        const findById = (id) => state?.sheets?.find((sheet) => sheet.sheet?._id === id);
        const sourceSheet = findById(sheetId);
        const destinationSheet = findById(destinationSheetId);
        if (sourceSheet && destinationSheet) {
          dispatch(schedulePageActions.swapGridsPosition({
            swappedGrids: [
            { _id: sourceSheet.sheet._id, position: destinationSheet.grid.position },
            { _id: destinationSheet.sheet._id, position: sourceSheet.grid.position },
          ]}))
        }
      } else {
        dispatch(schedulePageActions.setGridPosition({ _id: sheetId, position: gridPosition }));
      }
    } catch (e) {
      console.error(e.message);
    }
  }, []);

  return { gridSetPosition };
};
